import { render, staticRenderFns } from "./VideoEdit.vue?vue&type=template&id=885a74a4"
import script from "./VideoEdit.vue?vue&type=script&lang=js"
export * from "./VideoEdit.vue?vue&type=script&lang=js"
import style0 from "./VideoEdit.vue?vue&type=style&index=0&id=885a74a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports